// @flow
/** @jsx h */
import { h } from 'preact';
import style from './style.css';
import { textTruncate } from '../../../utils/stringOperations';
import type { CategoryType } from '../../../modelType/bicType';
import { getStorageLenderId } from '../../../utils/lenderTheme';

type Props = {
  lenderId: string,
  tile: CategoryType,
  tileClickAction: Function,
};

const Category = ({
  lenderId = getStorageLenderId(),
  tile,
  index,
  tileClickAction,
}: Props) => {
  return (
    <div
      onClick={tileClickAction}
      className={`${style.tileContainer} cursorPointer`}>
      <div className={style.categoryImgContainer}>
        <img
          src={
            tile.attributes ? tile.attributes.iconImgUrl : tile.desktopImgUrl
          }
          style={{ width: tile.id === 'allCategoriesTile' ? '31px' : '100%' }}
          alt='category-logo'
          className={style.categoryImg}
        />
      </div>
      <div className={style.tileDescription}>
        <h2 className={style.categoryTitle}>{tile.name}</h2>
      </div>
    </div>
  );
};

export default Category;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/category/index.js